import styled from '@emotion/styled';

const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export default Main;
